/**
 * @property {function} callback
 * @method sendCallback
 * @method onCallback
 * @method clearCallback
 */
export function CallbackEvent () {
    this.callback = null;

     this.sendCallback = function (data) {
         if (typeof this.callback == 'function') {
             this.callback(data);
         }
     }

     this.onCallback = function (callback) {
         if (typeof callback == 'function') {
             this.callback = callback;
         }
     }

     this.clearCallback = function () {
         this.callback = null;
     }
 }
